var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStudyQuizitOutline = function SvgStudyQuizitOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2.5,
    d: "M12.12 12a4 4 0 0 1 7.773 1.333c0 2.667-4 4-4 4m.106 5.334h.014M29.333 16c0 7.364-5.97 13.333-13.334 13.333S2.666 23.363 2.666 16 8.636 2.667 15.999 2.667 29.333 8.637 29.333 16"
  })));
};
export default SvgStudyQuizitOutline;